export const dividerStyle = '@4xl:border-main-divider @4xl:border-b';
export const firstCellStyle = 'w-80 flex-shrink-0';
export const COLS_LENGTH_FOR_SCROLL = 2;
export const COLUMN_WIDTH = 4 * 80 + 40; // w-80 + pl-10 = 360px
//# sourceMappingURL=constants.js.map